import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import classes from "./NotificationModal.module.css";

export const NotificationModal = ({ children, open, onBackdropClick, onDelete }) => {
    const [isOpen, setIsOpen] = useState(open);
    const dialog = useRef();

    useEffect(() => {
        const modal = dialog.current;
        if (open) {
            modal.showModal();
            setIsOpen(true);
        } else {
            modal.close();
            setIsOpen(false);
        }
    }, [open]);

    const handleClick = (e) => {
        const dialogDimensions = dialog.current.getBoundingClientRect();
        if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
        ) {
            onBackdropClick?.();
        }
    };

    return createPortal(
        <dialog 
            ref={dialog} 
            className={classes.smallModal} 
            onClick={handleClick}
            aria-modal="true"
            style={{
                position: isOpen ? 'fixed' : 'none',
                top: isOpen ? '50%' : '0',
                left: isOpen ? '50%' : '0',
                transform: isOpen ? 'translate(-50%, -50%)' : 'translate(0, 0)',
                display: isOpen ? 'block' : 'none',
            }}
        >
            <div  onClick={onBackdropClick} className={classes.closeButton}>
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.50947 8.5L0 0.990535L0.990535 0L8.5 7.50947L16.0095 0L17 0.990535L9.49054 8.5L17 16.0095L16.0095 17L8.5 9.49054L0.990535 17L0 16.0095L7.50947 8.5Z" fill="#1F1F1F"/>
                </svg>
            </div>
            <div className={classes.content}>
                <h1 className='titleSemibold3'>Alle {children} löschen?</h1>
                <span>Mit dieser Auswahl löschst du alle vorhandenen {children}.</span>
            </div>
            <div className={classes.buttons}>
                <button onClick={onDelete} className={`${classes.cancelButton} mediumLarge`}>Löschen</button>
                <button onClick={onBackdropClick} className={`${classes.deleteButton} mediumLarge`}>Abbrechen</button>
            </div>
        </dialog>,
        document.getElementById('notificationModal')
    );
};